import { render, staticRenderFns } from "./feedbackCard.vue?vue&type=template&id=4ddf295e&scoped=true"
import script from "./feedbackCard.vue?vue&type=script&lang=ts"
export * from "./feedbackCard.vue?vue&type=script&lang=ts"
import style0 from "./feedbackCard.vue?vue&type=style&index=0&id=4ddf295e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf295e",
  null
  
)

export default component.exports